import type { AnalyticsContext, ClientType, Platform, ScreenBucket } from './types';
import { getAnalyticsConfig } from './config';

declare global {
  interface Window {
    __TAURI_INTERNALS__?: unknown;
  }
}

function detectClient(): ClientType {
  if (typeof window === 'undefined') return 'web';
  if ('__TAURI_INTERNALS__' in window && window.__TAURI_INTERNALS__) return 'tauri';
  if (window.matchMedia?.('(display-mode: standalone)').matches) return 'pwa';
  return 'web';
}

function detectPlatform(): Platform {
  if (typeof navigator === 'undefined') return 'web';

  const uaData = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData;
  const raw = (uaData?.platform ?? navigator.platform ?? '').toLowerCase();

  if (raw.includes('mac')) return 'macos';
  if (raw.includes('win')) return 'windows';
  if (raw.includes('linux')) return 'linux';
  if (/iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())) return 'ios';
  if (/android/.test(navigator.userAgent.toLowerCase())) return 'android';
  return 'web';
}

function detectScreenBucket(): ScreenBucket {
  if (typeof window === 'undefined') return 'desktop';
  if (window.innerWidth < 768) return 'mobile';
  if (window.innerWidth < 1024) return 'tablet';
  return 'desktop';
}

export function detectContext(): AnalyticsContext {
  return {
    client: detectClient(),
    platform: detectPlatform(),
    screenBucket: detectScreenBucket(),
    appVersion: getAnalyticsConfig().appVersion || undefined,
    locale: typeof navigator !== 'undefined' ? navigator.language : undefined,
  };
}
